import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "./i18n";
import App from "@/App";
import { registerServiceWorker } from "./serviceWorkerRegistration";

window.deferredEdujacInstallPrompt = null;

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  window.deferredEdujacInstallPrompt = event;
  window.dispatchEvent(new Event("edujac-install-available"));
});

window.addEventListener("appinstalled", () => {
  window.deferredEdujacInstallPrompt = null;
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

registerServiceWorker();
